/* eslint-disable import/no-cycle */
import { initialState } from './initialState';
import {
	setSelectedItem,
	setSelectedItemChangesClone,
	setIsSavingEditedItem,
	setErrorMessageSaveEditedItem,
  
	setNewItem,
	setIsSavingNewItem,
  setErrorMessageSaveNewItem,
  
	setIsDeletingItem,
	setErrorMessageDeleteItem,
	setShowConfirmation,
  setConfirmationMessageKey,
  
  setShowValidation,

  reset,
} from './actions';
import { ROOT_SLICE } from './constants';
import {
	selectThisSlice,
} from './selectors/selectors';

// ************
// PARTS
// ************
const reducerParts = {
	[reset]: state => ({
		...state,
		[ROOT_SLICE]: { ...initialState }
	}),

	[setSelectedItem]: (state, { payload: { item } }) => {
		const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, selectedItem: item }
		};
	},

	[setSelectedItemChangesClone]: (state, { payload: { clone } }) => {
		const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, selectedItemChangesClone: clone }
		};
	},

	[setNewItem]: (state, { payload: { newItem } }) => {
		const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, newItem }
		};
	},

	[setIsSavingNewItem]: (state, { payload: { isSavingNewItem } }) => {
		const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, isSavingNewItem }
		};
	},

	[setErrorMessageSaveNewItem]: (
		state,
		{ payload: { errorMessageSaveNewItem } }
	) => {
		const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, errorMessageSaveNewItem }
		};
	},

	[setIsSavingEditedItem]: (state, { payload: { isSavingEditedItem } }) => {
		const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, isSavingEditedItem }
		};
	},

	[setErrorMessageSaveEditedItem]: (
		state,
		{ payload: { errorMessageSaveEditedItem } }
	) => {
		const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, errorMessageSaveEditedItem }
		};
	},

	[setIsDeletingItem]: (state, { payload: { isDeletingItem } }) => {
		const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, isDeletingItem }
		};
	},

	[setErrorMessageDeleteItem]: (
		state,
		{ payload: { errorMessageDeleteItem } }
	) => {
		const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, errorMessageDeleteItem }
		};
	},

	[setShowConfirmation]: (state, { payload: { showConfirmation } }) => {
		const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, showConfirmation }
		};
	},

	[setConfirmationMessageKey]: (
		state,
		{ payload: { confirmationMessageKey } }
	) => {
		const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, confirmationMessageKey }
		};
  },
  
  [setShowValidation]: (
		state,
		{ payload: { show } }
	) => {
		const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, showValidation: show }
		};
  },
};

export default reducerParts;
